import { Link } from "react-router-dom";
import { TableContainer } from "./styles";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import { toast } from "react-toastify";
import Loading from "../../Loading";

const Table = ({ statusSelecionado, textoPesquisa }) => {
  const [criativo, setCriativo] = useState([]);
  const [loading, setLoading] = useState(true)

  function buscarCriativo() {
    setLoading(true)

    api
      .get("/criativo")
      .then((response) => {
        setLoading(false)
        setCriativo(response.data.data.criativos);
      })
      .catch((error) => {
        setLoading(false)
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  }
  useEffect(() => {
    buscarCriativo();
  }, []);

  const colunas = ["Id", "Título", "Status", "Solicitante", "Prazo Estimado", "Última atualização"];
  const filtrarCategoria = (criativo) => {
    const criativoFiltrado =
      !statusSelecionado || criativo.status === statusSelecionado;
    const pesquisaFiltrada =
      !textoPesquisa ||
      criativo.titulo.toLowerCase().includes(textoPesquisa.toLowerCase());

    const idCategoria = parseInt(textoPesquisa);
    const idFiltrado = !isNaN(idCategoria) && criativo.id === idCategoria;

    return criativoFiltrado && (pesquisaFiltrada || idFiltrado);
  };

  const criativosFiltrados = criativo.filter(filtrarCategoria);

  return (
    <TableContainer>
      {
        loading ?
          <div className="loading">
            <Loading />
          </div>
          :
          criativosFiltrados.length > 0 ?
            <table>
              <thead>
                <tr>
                  {colunas.map((coluna) => (
                    <th key={coluna} className={coluna == "Título" ? "text-start" : ""}>{coluna}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {criativosFiltrados.map((criativo) => (
                  <tr className="map" key={criativo.id}>
                    <td>#{criativo.id}</td>
                    <td className="text-start">{criativo.titulo}</td>
                    <td className="min-width200">
                      <span className={"status" + " " + criativo.status.trim()}>
                        {criativo.status}
                      </span>
                    </td>
                    <td>
                      {criativo.usuario_nome} {criativo.usuario_sobrenome}
                    </td>
                    <td>
                      {criativo?.prazo_estimado?.split("-").reverse().join("/")}
                    </td>
                    <td>{criativo.data_atualizacao}</td>
                    <td className="td-editar">
                      <Link
                        to={`/criativo/editar/${criativo.id}`}
                        className="editar"
                        htmlFor="editar"
                      >
                        acompanhar {">"}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table> :
            <div>
              <h2>Nenhum criativo encontrado 😢</h2>
            </div>
      }
    </TableContainer>
  );
};

export default Table;
